import config from '../ionic.config.json';

export class ApplicationConfig {
  private endPointLocation = (<any>config).endPointLocation;
  private base = (<any>config).base;
  public readonly apiEndpoints: { [key: string]: string };

  constructor() {
    let endpoints = {};
    endpoints['registration'] = this.base + this.endPointLocation + '/accounts/register';
    endpoints['forgotPassword'] = this.base + this.endPointLocation + '/accounts/forgot-password';
    endpoints['resetPassword'] = this.base + this.endPointLocation + '/accounts/reset-password';
    endpoints['completeRegistration'] = this.base + this.endPointLocation + '/accounts/complete-registration';
    endpoints['login'] = this.base + this.endPointLocation + '/token';
    endpoints['materials'] = this.base + this.endPointLocation + '/materials';
    endpoints['materialsDetails'] = this.base + this.endPointLocation + '/materials/material-details';
    endpoints['endmills'] = this.base + this.endPointLocation + '/endmills';
    endpoints['endmillsDetails'] = this.base + this.endPointLocation + '/endmills/tool-details';
    endpoints['operations'] = this.base + this.endPointLocation + '/operations';
    endpoints['machine'] = this.base + this.endPointLocation + '/machine';
    endpoints['bannedUserNames'] = this.base + this.endPointLocation + '/banned-usernames';
    endpoints['countries'] = this.base + this.endPointLocation + '/countries';
    endpoints['paramsAndRecs'] = this.base + this.endPointLocation + '/parameters-and-recommendations';
    endpoints['pdfSupportInfo'] = this.base + this.endPointLocation + '/pdf-support-info';
    endpoints['logUserData'] = this.base + this.endPointLocation + '/log-user-data';
    endpoints['endmillSearchStrings'] = this.base + this.endPointLocation + '/endmills/search-strings';
    endpoints['singleEndmill'] = this.base + this.endPointLocation + '/endmills/get-single-endmill';
    endpoints['materialsDetailsForEndmill'] = this.base + this.endPointLocation + '/materials/endmill-material-details';
    endpoints['toolDetailsForEndmill'] = this.base + this.endPointLocation + '/endmills/endmill-tool-details';
    endpoints['operationForEndmill'] = this.base + this.endPointLocation + '/operations/endmill-operations';
    endpoints['endmillMapModeTwoCount'] =
      this.base + this.endPointLocation + '/endmills/get-map-mode-two-endmill-count';
    endpoints['paramsAndRecsProductkeyGrouping'] =
      this.base + this.endPointLocation + '/parameters-and-recommendations/product-key-group';
    endpoints['latestToolVersion'] = `${this.base}${this.endPointLocation}/tool-version/latest`;
    this.apiEndpoints = endpoints;
  }
}
